module.exports = __webpack_public_path__ + "files/d5f77831b7d5bce38f4721eb77225538.png";